//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'
import moment from 'moment'

export default {
  props: {
    date: {
      default: ''
    },
    time: {
      default: ''
    }
  },
  data: function () {
    return {
      value: `${this.date} ${this.time}`.trim()
    }
  },
  watch: {
    date: {
      handler (val) {
        console.log('date', val)
        if (val) {
          let v = `${val} ${this.time}`.trim()
          // console.log('this.value', this.value)
          // console.log('v', v)
          let r = this.value
          if (_.isDate(this.value)) {
            r = moment(v).format('yyyy-MM-DD HH:mm:ss')
          }
          if (r !== v) {
            this.value = moment(v).toDate()
          }
        }
      }
    },
    time: {
      handler (val) {
        console.log('time', val)
        if (val) {
          let v = `${this.date} ${val}`.trim()
          let r = this.value
          if (_.isDate(this.value)) {
            r = moment(v).format('yyyy-MM-DD HH:mm:ss')
          }
          if (r !== v) {
            this.value = moment(v).toDate()
          }
        }
      }
    },
    value: {
      handler (val) {
        console.log('value', val)
        if (val) {
          if (_.isDate(val)) {
            val = moment(val).format('YYYY-MM-DD HH:mm:ss')
          }
          // console.log('val', val)
          let date = val.substr(0, 10)
          let time = val.substr(11)
          if (this.date !== date) {
            this.$emit('update:date', date)
          }
          if (this.time !== time) {
            this.$emit('update:time', time)
          }
        }
      }
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {

  }
}
